import type { TImportedFrom } from "@/shared/services/pages/types";
import type { ImportSource } from "../stores/file-to-storydoc-generation.store";

type MarkerSource = {
  fileName: string;
  title: string;
  jobId: string | null;
  source: ImportSource;
};

export const buildImportedFrom = (
  { fileName, title, jobId, source }: MarkerSource,
  now: Date = new Date(),
): TImportedFrom => ({
  fileName: fileName.trim() || title,
  jobId,
  source,
  importedAt: now.toISOString(),
});
